/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hours: NonNullable<unknown>, minutes: NonNullable<unknown> }} Partner_Billing_Board_Sync_HoursInputs */



/**
* | output |
* | --- |
* | "Accounting sync · {hours}h {minutes}m ago" |
*
* @param {Partner_Billing_Board_Sync_HoursInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_sync_hours = /** @type {((inputs: Partner_Billing_Board_Sync_HoursInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Sync_HoursInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Buchhaltungsabgleich · vor ${i?.hours} Std. ${i?.minutes} Min.`)
	return /** @type {LocalizedString} */ (`Accounting sync · ${i?.hours}h ${i?.minutes}m ago`)
});